import {makeObservable, observable, runInAction} from "mobx";
import {message, notification} from "antd";
import ProductModel from "@home/model/ProductModel";
import {request} from "@/framework/network/request";
import SkuModel from "@home/model/SkuModel";

export default class DetailsStore {
  loading: boolean
  visibleAttr: any
  productDetails: ProductModel
  selectSku: SkuModel

  constructor() {
    makeObservable(this, {
      loading: observable,
      visibleAttr: observable,
      productDetails: observable,
      selectSku: observable,
    })
    this.loading = false;
    this.visibleAttr = {unvisibleAttr: '', unvisibleAttrValue: '', visibleAttrValue: '',}
    this.productDetails = {}
    this.selectSku = {}
  }

  getProductDetails = async (id: string) => {
    // this.productDetails
    this.loading = true
    try {
      const res = await request.get(`/public/product/${id}`)
      console.log("res", res)
      if (res.status === 1) {
        //const productImgs:Array<string> =res.data.pictures.split(",")
        // console.log("productImgs",productImgs)
        runInAction(() => {
          this.productDetails = res.data
          // this.loading = false
        })
      }
      runInAction(() => {
        this.loading = false
      })
    } catch (e) {
      this.loading = false
      notification.error({
        message: '获取商品详细数据错误',
        description: e.message
      })
    }
  }

  checkAttr = (attrId: string, attrValueId: string) => {
    runInAction(() => {
      this.loading = true
    })
    if (this.visibleAttr.unvisibleAttrValue === attrValueId) {
      runInAction(() => {
        this.visibleAttr = {unvisibleAttr: '', unvisibleAttrValue: '', visibleAttrValue: ''}
        this.loading = false
      })
    } else {
      let attrValueIds: string[] = []
      this.productDetails.sku?.forEach((it: any) => {
        if (it.attr1Id === attrId && it.attr1ValueId === attrValueId) {
          attrValueIds.push(it.attr2ValueId)
        } else if (it.attr2Id === attrId && it.attr2ValueId === attrValueId) {
          attrValueIds.push(it.attr1ValueId)
        }
      })

      runInAction(() => {
        this.visibleAttr = {
          unvisibleAttr: attrId,
          unvisibleAttrValue: attrValueId,
          visibleAttrValue: attrValueIds.join(",")
        }
        this.loading = false
      })
    }
  }

  setSelectSku = (sku: SkuModel) => {
    this.selectSku = sku
  }

  saveCard = async () => {
    try {
      this.loading = true
      const skuData = {
        number: 1,
        price: this.selectSku.price,
        productId: this.selectSku.productId,
        skuId: this.selectSku.id,
      }
      const res = await request.post(`/cart`, skuData)
      if (res.status === 1) {
        await message.success('成功加入购物车', 2)
      } else {
        await message.error(res.message)
      }
      this.loading = false
    } catch (e) {
      this.loading = false
      notification.error({
        message: '获取商品详细数据错误',
        description: e.message
      })
    }

  }

}